import _slicedToArray from "/drone/src/node_modules/@babel/runtime/helpers/esm/slicedToArray";
import { useCallback } from 'react';
import { useControlledState } from './useControlledState';
export var useControlledFlagState = function useControlledFlagState(defaultValue, value, onValueUpdate) {
  var _useControlledState = useControlledState(defaultValue, value, onValueUpdate),
      _useControlledState2 = _slicedToArray(_useControlledState, 2),
      realValue = _useControlledState2[0],
      setRealValue = _useControlledState2[1];

  var turnOn = useCallback(function () {
    setRealValue(true);
  }, [setRealValue]);
  var turnOff = useCallback(function () {
    setRealValue(false);
  }, [setRealValue]);
  var toggle = useCallback(function () {
    setRealValue(!realValue);
  }, [setRealValue, realValue]);
  return [realValue, setRealValue, turnOn, turnOff, toggle];
};